import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SampleService } from "../../../services/index";
import * as fromCommonStore from "../../../store";
import * as commonActions from "../../../store/actions/common.actions";
import { SamplePrint } from "./samplePrint";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./sample.html",
})
export class SampleComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  matchList: any;
  sampleList: any;
  shadelist = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  styleData: any;
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "sd.samp_id",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("stickerTemplate") stickerTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    sample_no: "",
    fab_design_no: "",
    shirt_design_no: "",
  };

  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private sampService: SampleService,
    public datePipe: DatePipe,
    private modalService: BsModalService,
    public toasterService: ToasterService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getSampleList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "Sample No",
        prop: "sample_no",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        cellClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Date",
        prop: "date_formatted",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        cellClass: "text-center",
        sortable: false,
      },
      {
        name: "Fab.Design No",
        prop: "fab_design_no",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Shirt.Design No",
        prop: "shirt_design_no",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Brand",
        prop: "brand",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        cellClass: "text-center",
        align: "right",
        headerClass: "text-center",
        type: "text",
      },
      {
        name: "Sample Qty",
        prop: "sample_qty",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        sortable: false,
      },

      {
        name: "Action",
        prop: "action",
        minWidth: 155,
        maxWidth: 155,
        width: 155,
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.editDeleteTemplate,
        cellClass: "text-center",
        isPrint: false,
      },

      {
        name: "Sticker",
        prop: "action",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.stickerTemplate,
        cellClass: "text-center",
        isPrint: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        this.addEditInvoice("Add", "");
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#sampleno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getSampleList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSampleList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getSampleList();
  }

  getSampleList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      fab_design_no: this.filterData.fab_design_no,
      sample_no: this.filterData.sample_no,
      shirt_design_no: this.filterData.shirt_design_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.sampService
      .sampleList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;

        let party = $("#filter_party_id").val();

        party = party == "" ? "All" : party;

        let subTitle: any;
        subTitle = {
          Party: party,
        };

        that.printConfig = {
          title: "Purchase Invoice",
          subTitle: subTitle,
          sumtitle: "TOTAL",
          columns: that.columns,
          rows: res.data,
        };
      });
  }

  clearFilter(): void {
    this.filterData.sample_no = "";
    this.filterData.fab_design_no = "";
    this.filterData.shirt_design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getSampleList();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  addEditInvoice(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getSampleList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "ADD SAMPLE",
          id: "AddEditSample",
          name: "ADD SAMPLE",
          mode: mode,
          data: row,
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "EDIT SAMPLE",
          id: "AddEditSample",
          name: "EDIT SAMPLE",
          mode: mode,
          data: row,
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "VIEW SAMPLE",
          id: "AddEditSample",
          name: "VIEW SAMPLE",
          mode: mode,
          data: row,
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  deleteInvoice(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Sample?",
      text: "You will not be able to recover this Sample",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.sampService
          .deleteSample(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getSampleList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  getStyleDetails(row) {
    let params = {
      style_no: row.style_no,
    };
    this.sampService.getStyleDetails(params).then((res: any) => {
      this.styleData = res.data;
      this.printSample("Print", row);
      //  this.loadeditsamplelist(row);
    });
  }

  bsModalRef: BsModalRef;
  printSample(mode: string, row: any): void {
    let that = this;
    setTimeout(function () {
      that.filterPanel.close();
    }, 10);

    this.bsModalRef = this.modalService.show(SamplePrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.title = mode + this.title + "Details";
    this.bsModalRef.content.mode = mode;
    this.bsModalRef.content.sampledata = Object.assign({}, row);
    this.bsModalRef.content.styledata = Object.assign({}, this.styleData);
    // this.bsModalRef.content.matchlist = this.matchList;
    (this.bsModalRef.content.tabID = this.tabID),
      (this.bsModalRef.content.tabTitle = this.title),
      this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
        if (this.title == "DesignStockComponent")
          this.store.dispatch(new commonActions.LoadAllParty());
        else this.store.dispatch(new commonActions.LoadAllCompany());
      });
  }

  loadeditsamplelist(row) {
    let params = {
      samp_id: row.samp_id,
    };
    this.sampService.getEditSampleList(params).then((res: any) => {
      this.shadeList(row);

      this.sampleList = res.data;
    });
  }
  shadeList(row) {
    // let coloList = row.sample_color;
    let sample_no = row.sample_no;
    let params = {
      sample_no: sample_no,
    };

    this.sampService.getShadeList(params).then((res: any) => {
      let data1: any = res.data;

      for (var i = 0; i < data1.length; i++) {
        for (var key in data1[i]) {
          let temp = data1[i][key];
          this.shadelist.push(temp);
        }
      }
      this.clickPrint(row, this.shadelist);
      console.log(res);
    });
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.sampService
      .sampleSticker(params)
      .then(function (res: any) {});
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/sample.ts